// This file is ported version of react-data-grid-addons which is no longer supported
// addressing FOSSA Uncontrolled Resource Consumption in parsejson issue
// see CORN-2478

import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';

export default DragDropContext(HTML5Backend);
